import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { urls } from 'shared/constants/routing.constants';
import { useEmailVerifyQuery } from 'redux/api/auth.api';
import { useLoading } from 'shared/hooks/useLoading';

export const EmailVerify = () => {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useEmailVerifyQuery({ uidb64, token });

  useLoading(isLoading);

  useEffect(() => {
    if (data) {
      navigate(urls.commonPages.home);
    }
  }, [data, navigate]);
  return <Box />;
};
